<div class="modal-header">
  <!--<h5 class="modal-title">Schedule Story Publishing</h5>-->
  <button type="button" (click)="cancel()" class="close">
    <span aria-hidden="true">
      <svg role="img">  
        <use xlink:href="#icon-close"></use>
      </svg>
    </span>
  </button>
</div>

<div class="modal-body">
  <form [formGroup]="scheduleForm">
    <!-- Story Info -->
    <div class="story-info">
      <h6 class="story-title">{{ storyTitle }}</h6>
      <small class="text-muted">Company Timezone: {{ companyTimezone }}</small>
    </div>

    <!-- General Error -->
    <div class="alert alert-danger" *ngIf="validationErrors.general">
      <i class="fas fa-exclamation-triangle mr-2"></i>
      {{ validationErrors.general }}
    </div>

    <div class="schedule-layout">
      <!-- Single Column Layout -->
     
      <h6 *ngIf="initialState?.currentInternalStatus && initialState?.currentPublicStatus">This story has already been published.</h6>

      <div class="schedule-options" *ngIf="!initialState?.currentInternalStatus || !initialState?.currentPublicStatus">
        
        <!-- Internal and Public Combined -->
        <div class="schedule-option compact" [class.active]="scheduleForm.get('bothEnabled')?.value" [class.disabled]="scheduleForm.get('internalEnabled')?.value || scheduleForm.get('publicEnabled')?.value   || (is_new_schedule && ((initialState?.currentInternalStatus || initialState?.currentPublicStatus)))">
          <div class="option-header">
            <h6>  Internal and Public </h6>

            <label class="switch">
              <input 
                type="checkbox" 
                formControlName="bothEnabled"
                (change)="onBothToggleChange()">
              <span class="slider"></span>
            </label>
          </div>
          
          <div class="date-time-buttons compact" *ngIf="scheduleForm.get('bothEnabled')?.value">
            <button 
              type="button" 
              class="date-btn compact"
              [class.active]="getFormattedDate('bothDate')"
              (click)="openDateTimePicker('both', 'date')">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getFormattedDate('bothDate') || 'Date' }}</span>
            </button>
            <button 
              type="button" 
              class="time-btn compact"
              [class.active]="scheduleForm.get('bothTime')?.value"
              (click)="openDateTimePicker('both', 'time')">
              <i class="fas fa-clock"></i>
              <span>{{ getDisplayTime('bothTime') }}</span>
            </button>
          </div>
          
          <!-- Both Schedule Summary -->
          <div class="schedule-summary-inline compact" *ngIf="scheduleForm.get('bothEnabled')?.value && getScheduleSummary('both') !== 'Not scheduled'">
            <div class="summary-item-inline">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getScheduleSummary('both') }}</span>
            </div>
          </div>
          
          <div class="invalid-feedback" *ngIf="validationErrors.both">
            {{ validationErrors.both }}
          </div>
          <span *ngIf="payload && payload.created_by && is_both"  class="author_details mb-1">Created by:&nbsp;{{ payload.created_by}}</span>
          <span *ngIf="payload && payload.updated_by && is_both" class="author_details">,&nbsp;Last updated by:&nbsp;{{ payload.updated_by}}</span>
        </div>

        <!-- Internal Publishing -->
        <div class="schedule-option compact"  [class.active]="scheduleForm.get('internalEnabled')?.value" [class.disabled]="scheduleForm.get('bothEnabled')?.value || initialState?.currentInternalStatus  ||  (is_new_schedule && (initialState?.currentInternalStatus))">
          <div class="option-header">
            <h6>Internal Only</h6>
            <label class="switch">
              <input 
                type="checkbox" 
                formControlName="internalEnabled"
                [disabled]="scheduleForm.get('bothEnabled')?.value"
                (change)="onInternalToggleChange()">
              <span class="slider"></span>
            </label>
          </div>
          
          <div class="date-time-buttons compact" *ngIf="scheduleForm.get('internalEnabled')?.value && !scheduleForm.get('bothEnabled')?.value">
            <button 
              type="button" 
              class="date-btn compact"
              [class.active]="getFormattedDate('internalDate')"
              (click)="openDateTimePicker('internal', 'date')">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getFormattedDate('internalDate') || 'Date' }}</span>
            </button>
            <button 
              type="button" 
              class="time-btn compact"
              [class.active]="scheduleForm.get('internalTime')?.value"
              (click)="openDateTimePicker('internal', 'time')">
              <i class="fas fa-clock"></i>
              <span>{{ getDisplayTime('internalTime') }}</span>
            </button>
          </div>
          
          <!-- Internal Schedule Summary -->
          <div class="schedule-summary-inline compact" *ngIf="scheduleForm.get('internalEnabled')?.value && !scheduleForm.get('bothEnabled')?.value && getScheduleSummary('internal') !== 'Not scheduled'">
            <div class="summary-item-inline">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getScheduleSummary('internal') }}</span>
            </div>
          </div>
          
          <div class="invalid-feedback" *ngIf="validationErrors.internal">
            {{ validationErrors.internal }}
          </div>
          <span *ngIf="payload && payload.created_by && payload.internal_only" class="author_details mb-1">Created by:&nbsp;{{ payload.created_by}}</span>
          <span *ngIf="payload && payload.updated_by && payload.internal_only" class="author_details">,&nbsp;Last updated by: &nbsp; {{ payload.updated_by}}</span>
        </div>

        <!-- Public Publishing -->
        <div class="schedule-option compact"  [class.active]="scheduleForm.get('publicEnabled')?.value" [class.disabled]="scheduleForm.get('bothEnabled')?.value || initialState?.currentPublicStatus ||  (is_new_schedule && ((initialState?.currentPublicStatus)))">
          <div class="option-header">
            <h6>Public Only</h6>
            <label class="switch">
              <input 
                type="checkbox" 
                formControlName="publicEnabled"
                [disabled]="scheduleForm.get('bothEnabled')?.value"
                (change)="onPublicToggleChange()">
              <span class="slider"></span>
            </label>
          </div>
          
          <div class="date-time-buttons compact" *ngIf="scheduleForm.get('publicEnabled')?.value && !scheduleForm.get('bothEnabled')?.value">
            <button 
              type="button" 
              class="date-btn compact"
              [class.active]="getFormattedDate('publicDate')"
              (click)="openDateTimePicker('public', 'date')">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getFormattedDate('publicDate') || 'Date' }}</span>
            </button>
            <button 
              type="button" 
              class="time-btn compact"
              [class.active]="scheduleForm.get('publicTime')?.value"
              (click)="openDateTimePicker('public', 'time')">
              <i class="fas fa-clock"></i>
              <span>{{ getDisplayTime('publicTime') }}</span>
            </button>
          </div>
          
          <!-- Public Schedule Summary -->
          <div class="schedule-summary-inline compact" *ngIf="scheduleForm.get('publicEnabled')?.value && !scheduleForm.get('bothEnabled')?.value && getScheduleSummary('public') !== 'Not scheduled'">
            <div class="summary-item-inline">
              <i class="fas fa-calendar-alt"></i>
              <span>{{ getScheduleSummary('public') }}</span>
            </div>
          </div>
          
          <div class="invalid-feedback" *ngIf="validationErrors.public">
            {{ validationErrors.public }}
          </div>

          <span *ngIf="payload && payload.created_by && payload?.public_only"  class="author_details mb-1">Created by:&nbsp;{{ payload.created_by}}</span>
          <span *ngIf="payload && payload.updated_by && payload?.public_only"  class="author_details">,&nbsp;Last updated by:&nbsp;{{ payload.updated_by}}</span>
        </div>

        <!-- Additional Options -->
        <div class="additional-options">
          <div class="option-row">
            <span>Spotlight Only</span>
            <div class="toggle-switch">
              <input 
                type="checkbox" 
                class="toggle-input" 
                id="spotlightOnly"
                formControlName="spotlightOnly">
              <label class="toggle-label" for="spotlightOnly"></label>
            </div>
          </div>
          
          <div class="option-row"  [ngClass]="{'no_campaign':initialState?.campaignId == null || initialState?.campaignId == 0 || initialState?.campaignId == -1 }">
            <span>Campaign Only</span>
            <div [ngClass]="{'no_campaign':initialState?.campaignId == null || initialState?.campaignId == 0 || initialState?.campaignId == -1 }" class="toggle-switch">
              <input 
                type="checkbox" 
                class="toggle-input" 
                id="campaignOnly"
                formControlName="campaignOnly">
              <label class="toggle-label" for="campaignOnly"></label>
            </div>
          </div>
        </div>

        <!-- Timezone Selection -->
        <div class="timezone-selection">
          <div class="timezone-header">
            <h6>Publishing Timezone</h6>
          </div>
          <div class="timezone-selector">
            <select formControlName="selectedTimezone" class="timezone-select">
              <option *ngFor="let tz of availableTimezones" [value]="tz.value">
                {{ tz.label }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>

<!-- Date/Time Picker Overlay Modal -->
<div class="picker-overlay" *ngIf="showDateTimePicker" (click)="closeDateTimePicker()">
  <div class="picker-modal" (click)="$event.stopPropagation()">
    
    <!-- Calendar Picker -->
    <div class="calendar-picker" *ngIf="currentPickerType === 'date'">
      <div class="picker-header">
        <!--<h5>Select Date</h5>-->
        <button type="button" class="close-btn" (click)="closeDateTimePicker()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="calendar-container">
        <div class="calendar-nav">
          <button type="button" (click)="previousMonth()" class="nav-btn">
            <i class="fas fa-chevron-left"></i>
          </button>
          <span class="month-year">{{ getMonthYearDisplay() }}</span>
          <button type="button" (click)="nextMonth()" class="nav-btn">
            <i class="fas fa-chevron-right"></i>
          </button>
        </div>

        <div class="calendar-grid">
          <div class="weekdays">
            <div class="weekday" *ngFor="let day of weekdays">{{ day }}</div>
          </div>
          <div class="dates">
            <button 
              type="button"
              *ngFor="let date of calendarDates" 
              class="date-cell"
              [class.other-month]="!date.currentMonth"
              [class.selected]="date.selected"
              [class.today]="date.today"
              [class.disabled]="date.disabled"
              [disabled]="date.disabled"
              (click)="selectDate(date)">
              {{ date.day }}
            </button>
          </div>
        </div>
      </div>
      
      <div class="picker-actions">
        <button type="button" class="btn btn-outline" (click)="closeDateTimePicker()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="applyDateTime()">
          Apply
        </button>
      </div>
    </div>

    <!-- Time Picker -->
    <div class="time-picker" *ngIf="currentPickerType === 'time'">
      <div class="picker-header">
        <!--<h5>Select Time</h5>-->
        <button type="button" class="close-btn" (click)="closeDateTimePicker()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <!-- Popular Times -->
      <div class="popular-times">
        <h6>Popular Times</h6>
        <div class="time-buttons">
          <button 
            type="button" 
            *ngFor="let time of popularTimes"
            class="time-option-btn"
            [class.selected]="isTimeSelected(time)"
            (click)="selectTime(time)">
            {{ time }}
          </button>
        </div>
      </div>
      
      <!-- Custom Time -->
      <div class="custom-time">
        <!--<h6>Custom Time</h6>-->
        <div class="time-inputs">
          <div class="hour-input">
            <label>Hour</label>
            <select [(ngModel)]="customHour" (change)="updateCustomTime()">
              <option *ngFor="let hour of [1,2,3,4,5,6,7,8,9,10,11,12]" [value]="hour">
                {{ hour }}
              </option>
            </select>
          </div>
          <div class="minute-input">
            <label>Minute</label>
            <select [(ngModel)]="customMinute" (change)="updateCustomTime()">
              <option *ngFor="let minute of [0,15,30,45]" [value]="minute">
                {{ minute.toString().padStart(2, '0') }}
              </option>
            </select>
          </div>
          <div class="period-input">
            <label>AM/PM</label>
            <select [(ngModel)]="customPeriod" (change)="updateCustomTime()">
              <option value="AM">AM</option>
              <option value="PM">PM</option>
            </select>
          </div>
        </div>
      </div>
      
      <div class="picker-actions">
        <button type="button" class="btn btn-outline" (click)="closeDateTimePicker()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="applyDateTime()">
          Apply
        </button>
      </div>
    </div>
    
  </div>
</div>

<div class="modal-footer">
  <button 
    type="button" 
    class="btn btn-outline btn-gray-light"
    (click)="cancel()">
    Cancel
  </button>
  <button 
    type="button" 
    class="btn btn-primary"
    [disabled]="is_new_schedule && (scheduleForm.invalid || isSaving || !hasValidScheduleData())"
    (click)="save()">
    <i *ngIf="isSaving" class="fas fa-spinner fa-spin mr-2"></i>
    Save Schedule
  </button>
</div>

